var _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
function SvgStar(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19 17",
    fill: "none"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#FCC500",
    d: "M9.499 14.274l-4.15 2.5a.908.908 0 01-.575.15.966.966 0 01-.525-.2 1.198 1.198 0 01-.35-.437.874.874 0 01-.05-.588l1.1-4.725L1.274 7.8a.958.958 0 01-.275-1.075c.067-.183.167-.333.3-.45.133-.116.317-.191.55-.225l4.85-.425 1.875-4.45c.083-.2.213-.35.388-.45.175-.1.354-.15.537-.15.183 0 .363.05.537.15.175.1.305.25.388.45l1.875 4.45 4.85.425c.233.034.417.109.55.225.133.117.233.267.3.45a.958.958 0 01-.275 1.075l-3.675 3.175 1.1 4.725a.874.874 0 01-.05.588c-.083.175-.2.32-.35.437a.966.966 0 01-.525.2.908.908 0 01-.575-.15l-4.15-2.5z"
  })));
}
export default SvgStar;